import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="center">
      <div className="card narrow text-center">
        <h2>Page not found</h2>
        <p className="muted">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link to="/">Back to dashboard</Link>
      </div>
    </div>
  );
}
